
        import 'BenefitLimit.906d18c.css-module'
        export default {"BenefitLimit":"BenefitLimit_BenefitLimit_906d18c","disabled":"disabled_BenefitLimit_906d18c","annualLimitSelect":"annualLimitSelect_BenefitLimit_906d18c","BoSelector":"BoSelector_BenefitLimit_906d18c"}
    